<template>
  <div class="entry-info-box person-info-page">
    <div class="title">
      <div class="title-left">
        <img src="https://images.snsports.cn/FnJ1snSwn9lMILUeyaZ2WUTxK9gL" alt="个人参赛表" class="title-logo" />
      </div>
      <div class="title-right" @click="showAction = true">···</div>
    </div>
    <div class="match-info" v-if="project.unionMatchId">
      <img :src="imageView(project.icon)" alt="">
      <div class="info">
        <div class="name">{{ project.unionMatchName }}</div>
        <div class="group">
          <span class="group-label">组别</span>
          <span class="group-value">{{ project.group || project.matchGroupName || '-' }}</span>
        </div>
      </div>
    </div>
    <div class="return" v-if="team.auditStatus == -1">
      <div class="return-title">审核建议</div>
      <div class="content overflow-text-tow">{{ team.auditRemark }}</div>
    </div>
    <div class="card-section" v-if="project.unionMatchId">
      <div class="card card-full card-team" @click="goUpdatePlayer">
        <div class="card-team-left">
          <span class="card-title">个人信息</span>
          <div class="team-left">
            <div class="team-logo" v-if="player.avatar">
              <img :src="imageView(player.avatar)" alt="" />
            </div>
            <span class="team-name">{{ player.trueName || '-' }}</span>
          </div>
        </div>
        <div class="card-team-action">
          <span class="card-link">查看详情</span>
        </div>
      </div>
      <div class="card-row">
        <div
          class="card card-half card-fee"
          v-if="showFeeCard"
          @click="goFeePayment"
        >
          <div class="card-title-row">
            <span class="card-title">参赛费用</span>
            <span class="card-link">{{ getPaymentStatus(team.orderStatus) }}</span>
          </div>
          <div class="card-desc">
            报名费：
            <span class="price">¥{{ feeAmountText }}</span>
          </div>
        </div>
        <EntryMiniStatCard
          v-if="showAgreementCard"
          layout="leader"
          class="card card-agreement"
          :class="agreementCardWidthClass"
          title="协议/承诺书"
          :status-done="teamAgreementStatusDone"
          :count-line-done="teamAgreementCountLineDone"
          desc-class="agreement-count"
          :show-time-row="showAgreementTimeRow"
          :time-text="agreementBottomText"
          @click="onAgreementCardClick"
        >
          <template #middle>已确认 {{ teamAgreementDone }}/{{ teamAgreementTotal }} 份</template>
        </EntryMiniStatCard>
        <EntryMiniStatCard
          v-if="showSurveyCard"
          layout="player"
          class="card card-survey"
          :class="surveyCardWidthClass"
          title="问卷/调研"
          :status-done="playerQuizStatusDone"
          :count-line-done="playerQuizCountLineDone"
          desc-class="survey-count"
          :show-time-row="showSurveyTimeRow"
          :time-text="surveyBottomText"
          @click.stop="onSurveyCardClick"
        >
          <template #middle>进度：已完成 {{ playerQuizDone }}/{{ playerQuizTotal }} 份</template>
        </EntryMiniStatCard>
      </div>
    </div>
    <EntryWxSubscribeRemind
      :visible="showWxSubscribeRemind"
      @click="goNotifySetting"
    />
    <div
      v-if="showGoMatchHomeBtn"
      class="go-match-home-btn"
      @click="goUnionMatchHome"
    >
      去赛事首页·关注赛程
    </div>
    <div style="height: 120px;"></div>
    <div class="footer-box" v-if="showButton">
      <div class="footer">
        <div class="left">
          <div>
            <span v-if="team.isSubmit === 0">未提交</span>
            <span v-else-if="team.auditStatus === 0 || team.auditStatus === 1" style="color: #909399">待确认</span>
            <span v-else-if="team.auditStatus === 3" style="color: #409EFF">已锁定</span>
            <span v-else-if="team.auditStatus === 2" style="color: #409EFF">已确认</span>
            <span v-else-if="team.auditStatus === -1" style="color: #F56C6C">已退回</span>
          </div>
        </div>
        <div
          ref="submitAuditGuideAnchor"
          class="right"
          v-if="showSubmitAuditButton"
          :style="{ 'background-color': jetlympic ? '#00A7FF' : 'var(--bg3)' }"
          @click="updateBMMatchTeam()"
        >提交审核</div>
      </div>
    </div>
    <van-action-sheet
      class="person-info-action-sheet-popup"
      v-model="showAction"
      :actions="actions"
      cancel-text="取消"
      close-on-click-action
      :safe-area-inset-bottom="true"
      @cancel="showAction = false"
      @select="handleAction"
    />
    <EntrySubmitAuditGuide
      :show="showSubmitAuditGuide"
      :hole-rect="submitAuditGuideRect"
      :viewport="submitAuditGuideViewport"
      :jetlympic="jetlympic"
      @dismiss="dismissSubmitAuditGuide"
    />
  </div>
</template>

<script>
import { QNImageUtil } from '@/utils'
import Vue from 'vue'
import {
  Dialog,
  Toast,
  ActionSheet
} from 'vant'
import {
  bangsaishiCreateTeamSignupOrder,
  bangsaishiCreatePlayerSignupOrder,
  getBMMatchTeamSignup,
  getBMMatchTeamPlayerQuestions,
  getCrmAccountWXSubscribeConfig,
  checkBMMatchBeforeSubmit,
  submitBMMatchTeam,
  cancelBMMatchTeam
} from '@/api/match'
import { getPassport } from '@/libs/passport'
import { getThemeAccountId } from '@/libs/cookie-storage'
import { orderStatusOptions } from '@/config'
import {
  parseAgreementDate,
  formatAgreementMd,
  phaseFromBeginEnd,
  scheduleBottomText
} from '@/utils/entry-agreement-dates'
import { goWxSubscribeNotify } from '@/utils/wx-subscribe-notify'
Vue.use(Dialog).use(Toast).use(ActionSheet)

import EntryWxSubscribeRemind from './EntryWxSubscribeRemind.vue'
import EntryMiniStatCard from './EntryMiniStatCard.vue'
import EntrySubmitAuditGuide from './EntrySubmitAuditGuide.vue'

export default {
  components: {
    EntryWxSubscribeRemind,
    EntryMiniStatCard,
    EntrySubmitAuditGuide
  },
  data() {
    return {
      unionMatchId: '',
      teamId: '',
      projectId: '',
      team: {},
      showAction: false,
      actions: [{ name: '取消报名', color: '#ee0a24' }],
      jetlympic: false,
      wxSubscribe: {
        isWxSubscribe: 0,
        configList: []
      },
      questionsData: {
        isOpen: 0,
        beginTime: null,
        endTime: null,
        list: []
      },
      incompleteRemindShown: false,
      player: {},
      project: {},
      showButton: false,
      showSubmitAuditGuide: false,
      submitAuditGuideRect: null,
      submitAuditGuideViewport: { w: 0, h: 0 },
      submitAuditGuideRetry: 0,
      submitAuditGuideDialogWait: 0
    }
  },
  computed: {
    /** 个人参赛表：金额单位固定展示「/人」（与球队统一付后台字段 feeMethod 无关） */
    feeAmountText() {
      if (!this.project || !this.project.feeAmount) return '0.00'
      const amount = (this.project.feeAmount / 100).toFixed(2)
      return `${amount}/人`
    },
    showFeeCard() {
      return this.project && this.project.isOpenCharge === 1 && this.project.feeMethod !== 0
    },
    /** 与 entry-info 一致：仅开启协议且配置了领队侧份数时展示，避免仅队员协议时出现 0/0 */
    showAgreementCard() {
      const m = this.project
      if (!m || (m.isUseAgreement !== 1 && m.isUseAgreement !== '1')) return false
      return this.teamAgreementTotal > 0
    },
    showSurveyCard() {
      const d = this.questionsData || {}
      return Number(d.isOpen) === 1
    },
    /** 与两卡并列时一致：单张协议/问卷卡也用 card-half（167px），不撑满整行 */
    surveyCardWidthClass() {
      if (!this.showSurveyCard) return ''
      return 'card-half'
    },
    agreementCardWidthClass() {
      if (!this.showAgreementCard) return ''
      return 'card-half'
    },
    surveyBeginTs() {
      return parseAgreementDate(this.questionsData && this.questionsData.beginTime)
    },
    surveyEndTs() {
      return parseAgreementDate(this.questionsData && this.questionsData.endTime)
    },
    surveyPhase() {
      return phaseFromBeginEnd(this.surveyBeginTs, this.surveyEndTs)
    },
    playerQuizList() {
      const raw = (this.questionsData && this.questionsData.list) || []
      return Array.isArray(raw) ? raw : []
    },
    playerQuizTotal() {
      return this.playerQuizList.length
    },
    playerQuizDone() {
      return this.playerQuizList.filter((q) => Number(q && q.completed) === 1).length
    },
    playerQuizStatusDone() {
      if (this.surveyPhase === 'before') return false
      if (this.playerQuizTotal <= 0) return false
      return this.playerQuizDone >= this.playerQuizTotal
    },
    playerQuizCountLineDone() {
      if (this.surveyPhase === 'before') return false
      if (this.playerQuizTotal <= 0) return false
      return this.playerQuizDone >= this.playerQuizTotal
    },
    surveyBottomText() {
      return scheduleBottomText(
        this.surveyPhase,
        this.surveyBeginTs,
        this.surveyEndTs,
        formatAgreementMd
      )
    },
    agreementBeginTs() {
      return parseAgreementDate(this.project && this.project.agreementBeginDate)
    },
    agreementEndTs() {
      return parseAgreementDate(this.project && this.project.agreementEndDate)
    },
    agreementPhase() {
      return phaseFromBeginEnd(this.agreementBeginTs, this.agreementEndTs)
    },
    teamAgreementTotal() {
      const n = Number(this.project && this.project.teamAgreementCount)
      return Number.isFinite(n) && n >= 0 ? n : 0
    },
    teamAgreementDone() {
      const n = Number(this.team && this.team.agreementConfirmedCount)
      return Number.isFinite(n) && n >= 0 ? n : 0
    },
    teamAgreementStatusDone() {
      if (this.agreementPhase === 'before') return false
      if (this.teamAgreementTotal <= 0) return false
      return this.teamAgreementDone >= this.teamAgreementTotal
    },
    teamAgreementCountLineDone() {
      if (this.agreementPhase === 'before') return false
      if (this.teamAgreementTotal <= 0) return false
      return this.teamAgreementDone >= this.teamAgreementTotal
    },
    agreementBottomText() {
      return scheduleBottomText(
        this.agreementPhase,
        this.agreementBeginTs,
        this.agreementEndTs,
        formatAgreementMd
      )
    },
    showAgreementTimeRow() {
      return this.agreementBottomText !== '—'
    },
    showSurveyTimeRow() {
      return this.surveyBottomText !== '—'
    },
    submitNeedAgreement() {
      const m = this.project
      if (!m) return false
      return m.submitNeedAgreement === 1 || m.submitNeedAgreement === '1'
    },
    showWxSubscribeRemind() {
      return Number(this.wxSubscribe.isWxSubscribe) === 1
    },
    /** 有系列赛 id 时展示「去赛事首页」入口 */
    showGoMatchHomeBtn() {
      return !!(this.unionMatchId || (this.project && this.project.unionMatchId))
    },
    /** 与 entry-info：提交审核按钮 + 引导锚点，兼容新建球队 isSubmit 形态 */
    showSubmitAuditButton() {
      const t = this.team
      if (!t) return false
      if (Number(t.auditStatus) === -1) return true
      const a = Number(t.auditStatus)
      if (a === 2 || a === 3) return false
      if (Number(t.isSubmit) === 1 || t.isSubmit === '1') return false
      return true
    }
  },
  mounted() {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.onSubmitAuditGuideResize)
      window.addEventListener('orientationchange', this.onSubmitAuditGuideResize)
    }
    if (window.localStorage.getItem('jetlympic')) {
      this.jetlympic = true
    }
    getPassport().then(res => {
      if (res) {
        this.unionMatchId = this.$route.query.unionMatchId
        this.projectId = this.$route.query.matchId
        this.teamId = this.$route.query.teamId
        this.getBMMatchTeamSignup()
      }
    })
  },
  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onSubmitAuditGuideResize)
      window.removeEventListener('orientationchange', this.onSubmitAuditGuideResize)
    }
  },
  methods: {
    fetchWxSubscribeConfig() {
      const accountId =
        (this.project && this.project.accountId) ||
        this.$route.query.accountId ||
        getThemeAccountId()
      if (accountId === '' || accountId == null) return
      getCrmAccountWXSubscribeConfig({ accountId, scene: 'match_single_signup' }).then(res => {
        if (!res) return
        const data = res.data != null ? res.data : res
        this.wxSubscribe = {
          isWxSubscribe: data.isWxSubscribe != null ? data.isWxSubscribe : 0,
          configList: Array.isArray(data.configList) ? data.configList : []
        }
      })
    },
    async goNotifySetting() {
      await goWxSubscribeNotify({
        wxSubscribe: this.wxSubscribe,
        matchId: this.projectId,
        teamId: this.teamId
      })
    },
    goUnionMatchHome() {
      const id = this.unionMatchId || (this.project && this.project.unionMatchId)
      if (!id) {
        Toast('缺少赛事信息')
        return
      }
      this.$router.push({ path: `/new-match-detail/${id}/home` })
    },
    fetchPlayerQuestions() {
      if (!this.projectId || !this.teamId || !this.player || !this.player.id) return
      getBMMatchTeamPlayerQuestions({
        matchId: this.projectId,
        teamId: this.teamId,
        playerId: this.player.id
      })
        .then((res) => {
          if (!res || res.data == null) {
            this.questionsData = { isOpen: 0, beginTime: null, endTime: null, list: [] }
            return
          }
          const d = res.data
          this.questionsData = {
            isOpen: d.isOpen,
            beginTime: d.beginTime != null ? d.beginTime : null,
            endTime: d.endTime != null ? d.endTime : null,
            list: Array.isArray(d.list) ? d.list : []
          }
        })
        .catch(() => {
          this.questionsData = { isOpen: 0, beginTime: null, endTime: null, list: [] }
        })
        .finally(() => {
          this.$nextTick(() => this.maybeShowIncompleteRemindPerson())
        })
    },
    onAgreementCardClick() {
      if (!this.showAgreementCard) return
      if (this.agreementPhase === 'before') {
        Toast('协议确认尚未开启')
        return
      }
      this.$router.push({
        path: '/entry-page/agreement-list',
        query: {
          type: 'leader',
          teamId: this.teamId,
          matchId: this.projectId,
          unionMatchId: this.unionMatchId
        }
      })
    },
    onSurveyCardClick() {
      if (!this.showSurveyCard) return
      if (this.surveyPhase === 'before') {
        Toast('问卷尚未开启')
        return
      }
      if (!this.player || !this.player.id) {
        Toast.fail('缺少队员信息，请稍后重试')
        return
      }
      this.$router.push({
        path: '/entry-page/player-quiz-list',
        query: {
          unionMatchId: this.unionMatchId,
          matchId: this.projectId,
          teamId: this.teamId,
          playerId: this.player.id
        }
      })
    },
    handleAction(item) {
      if (item.name === '取消报名') {
        this.cancelBMMatchTeam()
      }
    },
    getPaymentStatus(value) {
      if (!this.project || this.project.isOpenCharge !== 1) return ''
      if (this.project.feeMethod === 0) return ''
      const order = orderStatusOptions.find(o => o.value == value)
      if (!order) return '待支付'
      return order.label
    },
    /**
     * 参赛费用卡片：GetBMMatchTeamSignup.team.orderId 有则去支付页；否则校验后按收费方式建单再跳转。
     */
    goFeePayment() {
      if (!this.project || !this.showFeeCard) return
      if (!this.teamId) {
        Toast.fail('缺少队伍信息')
        return
      }
      getBMMatchTeamSignup({ matchId: this.projectId, teamId: this.teamId }).then(res => {
        if (!res || !res.data) return
        const team = res.data.team || {}
        const match = res.data.match || this.project

        if (team.orderId) {
          const cat = match.feeMethod === 1 ? 1 : 0
          let url = `/entry-page/payment?orderId=${team.orderId}&unionMatchId=${this.unionMatchId}&category=${cat}&matchId=${this.projectId}&teamId=${this.teamId}`
          if (cat === 1 && this.player && this.player.id) {
            url += `&playerId=${this.player.id}`
          }
          this.$router.push(url)
          return
        }

        checkBMMatchBeforeSubmit({ teamId: this.teamId, matchId: this.projectId }).then(ok => {
          if (!ok) return
          if (match.feeMethod === 1) {
            const playerId = this.player && this.player.id
            if (!playerId) {
              Toast.fail('缺少队员信息，无法创建订单')
              return
            }
            bangsaishiCreatePlayerSignupOrder({
              matchId: this.projectId,
              teamId: this.teamId,
              playerId
            }).then(r => {
              if (r && r.data && r.data.orderId) {
                this.$router.push(
                  `/entry-page/payment?orderId=${r.data.orderId}&unionMatchId=${this.unionMatchId}&category=1&matchId=${this.projectId}&teamId=${this.teamId}&playerId=${playerId}`
                )
              }
            })
          } else {
            bangsaishiCreateTeamSignupOrder({ matchId: this.projectId, teamId: this.teamId }).then(r => {
              if (r && r.data && r.data.orderId) {
                this.$router.push(
                  `/entry-page/payment?orderId=${r.data.orderId}&unionMatchId=${this.unionMatchId}&category=0&matchId=${this.projectId}&teamId=${this.teamId}`
                )
              }
            })
          }
        })
      })
    },
    canSubmitWithAgreementRule() {
      if (!this.submitNeedAgreement) return true
      if (this.agreementPhase === 'before') {
        Dialog.alert({
          message: '协议确认尚未开启，暂不可提交审核',
          confirmButtonText: '确定'
        })
        return false
      }
      if (this.teamAgreementTotal <= 0) return true
      if (this.teamAgreementDone < this.teamAgreementTotal) {
        Dialog.alert({
          message: '请先确认全部协议后再提交审核',
          confirmButtonText: '确定'
        })
        return false
      }
      return true
    },
    maybeShowIncompleteRemindPerson() {
      if (this.incompleteRemindShown) return
      if (!this.projectId || !this.teamId) return
      const needAgree =
        this.showAgreementCard &&
        this.teamAgreementTotal > 0 &&
        this.teamAgreementDone < this.teamAgreementTotal &&
        this.agreementPhase === 'during'
      const needSurvey =
        this.showSurveyCard &&
        this.playerQuizTotal > 0 &&
        this.playerQuizDone < this.playerQuizTotal &&
        this.surveyPhase === 'during'
      if (!needAgree && !needSurvey) return
      const ends = []
      if (needAgree && this.agreementEndTs) ends.push(this.agreementEndTs.getTime())
      if (needSurvey && this.surveyEndTs) ends.push(this.surveyEndTs.getTime())
      this.incompleteRemindShown = true
      const msg =
        ends.length > 0
          ? `协议确认和问卷填写通道已开启，请在 ${formatAgreementMd(new Date(Math.min(...ends)))} 前完成相关操作`
          : '协议确认和问卷填写通道已开启，请在提交审核前完成相关操作'
      Dialog.alert({ message: msg, confirmButtonText: '确定' })
    },
    goUpdatePlayer() {
      this.$router.push(`/entry-page/entry-info-person?unionMatchId=${this.unionMatchId}&matchId=${this.projectId}&teamId=${this.teamId}`)
    },
    imageView(img) {
      if (!img) return ''
      return QNImageUtil.imageView(img)
    },
    cancelBMMatchTeam() {
      if ((this.project.isOpenCharge === 1 && this.project.feeMethod === 1 && this.project.isChargeCount > 0) || (this.project.isOpenCharge === 1 && (this.project.feeMethod === 2 || this.project.feeMethod === 3) && (this.project.orderStatus === 1 || this.project.orderStatus === 2))) {
        Dialog.alert({
          title: '取消失败',
          message: '已有队员支付报名费用，取消报名请联系组委会',
        })
        return
      }
      Dialog.confirm({
        title: '是否取消报名',
        message: '取消后，数据将丢失',
      }).then(() => {
        const params = {
          matchId: this.projectId,
          teamId: this.teamId
        }
        cancelBMMatchTeam(params).then(res => {
          if (res) {
            Toast.success('取消成功')
            this.$router.back()
          }
        })
      })
    },
    updateBMMatchTeam() {
      if (!this.canSubmitWithAgreementRule()) return
      console.log(this.team);
      
      if (this.project.isOpenCharge === 1 &&(this.project.feeMethod === 2 || this.project.feeMethod === 3) && (this.team.orderStatus !== 1 && this.team.orderStatus !== 2)
      ) {
        const params = {
          teamId: this.teamId,
          matchId:this.projectId
        }
        checkBMMatchBeforeSubmit(params).then(res => {
          if (res) {
            Dialog.confirm({
              title: '尚未支付',
              message: '尚未支付，请前往支付费用',
            }).then(() => {
              const params = {
                matchId:this.projectId,
                teamId: this.teamId
              }
              bangsaishiCreateTeamSignupOrder(params).then(res => {
                if (res) {
                  this.$router.push(`/entry-page/payment?orderId=${res.data.orderId}&unionMatchId=${this.unionMatchId}&category=0&matchId=${this.projectId}&teamId=${this.teamId}`)
                }
              })
            })
          }
        })
      } else {
        checkBMMatchBeforeSubmit({
          teamId: this.teamId,
          matchId:this.projectId
        }).then(res => {
          if (res) {
            const params = {
              teamId: this.teamId,
              matchId:this.projectId
            }
            submitBMMatchTeam(params).then(res => {
              if (res) {
                Dialog.alert({
                  message: '报名提交成功',
                  confirmButtonText: '确定'
                }).then(() => {
                  this.getBMMatchTeamSignup()
                })
              }
            })
          }
        })
      }
    },
    getBMMatchTeamSignup() {
      const params = {
        matchId: this.projectId
      }
      if (this.teamId) {
        params.teamId = this.teamId
      }
      getBMMatchTeamSignup(params).then(res => {
        if (res) {
          const data = res.data || {}

          if (data.team) {
            this.showButton = data.team.auditStatus != 2
          } else {
            this.showButton = true
          }
          this.project = data.match
          this.team = data.team || {}
          const players = data.players || []
          if (players.length > 0) {
            this.player = players[0]
            this.fetchWxSubscribeConfig()
            this.fetchPlayerQuestions()
            this.$nextTick(() => this.maybeShowIncompleteRemindPerson())
          } else {
            this.fetchWxSubscribeConfig()
          }
          this.scheduleTryShowSubmitAuditGuide()
        }
      })
    },
    submitAuditGuideStorageKey() {
      return `signup_sheet_submit_audit_person_${this.projectId || ''}_${this.teamId || this.team.id || ''}`
    },
    updateSubmitAuditViewport() {
      if (typeof window === 'undefined') return
      this.submitAuditGuideViewport = { w: window.innerWidth, h: window.innerHeight }
    },
    measureSubmitAuditAnchor() {
      const el = this.$refs.submitAuditGuideAnchor
      if (!el) return null
      const rect = el.getBoundingClientRect()
      return {
        top: rect.top,
        left: rect.left,
        width: rect.width,
        height: rect.height
      }
    },
    scheduleTryShowSubmitAuditGuide() {
      const delays = [500, 1200, 2400, 3800]
      delays.forEach((ms) => {
        setTimeout(() => {
          if (this.showSubmitAuditGuide) return
          this.tryShowSubmitAuditGuide()
        }, ms)
      })
    },
    tryShowSubmitAuditGuide() {
      if (!this.team || !this.project) return
      if (this.showSubmitAuditGuide) return
      if (!this.showSubmitAuditButton || !this.showButton) return
      if (!(this.teamId || (this.team && this.team.id))) return
      try {
        if (localStorage.getItem(this.submitAuditGuideStorageKey()) === '1') return
      } catch (e) {
        void e
      }
      if (typeof document !== 'undefined' && document.querySelector('.van-dialog')) {
        this.submitAuditGuideDialogWait += 1
        if (this.submitAuditGuideDialogWait <= 15) {
          setTimeout(() => this.tryShowSubmitAuditGuide(), 400)
        }
        return
      }
      this.submitAuditGuideDialogWait = 0
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          this.updateSubmitAuditViewport()
          const r = this.measureSubmitAuditAnchor()
          if (!r || r.width < 4 || r.height < 4) {
            this.submitAuditGuideRetry += 1
            if (this.submitAuditGuideRetry <= 24) {
              setTimeout(() => this.tryShowSubmitAuditGuide(), 400)
            } else {
              this.submitAuditGuideRetry = 0
            }
            return
          }
          this.submitAuditGuideRetry = 0
          this.submitAuditGuideRect = r
          this.showSubmitAuditGuide = true
        })
      })
    },
    dismissSubmitAuditGuide() {
      try {
        localStorage.setItem(this.submitAuditGuideStorageKey(), '1')
      } catch (e) {
        void e
      }
      this.showSubmitAuditGuide = false
      this.submitAuditGuideRect = null
    },
    onSubmitAuditGuideResize() {
      if (!this.showSubmitAuditGuide) return
      this.updateSubmitAuditViewport()
      const r = this.measureSubmitAuditAnchor()
      if (r) this.submitAuditGuideRect = r
    }
  }
}
</script>

<style lang="scss" scoped>
.entry-info-box.person-info-page {
  background: var(--bg2);
  padding: 0 14px;
  min-height: 100vh;
  padding-top: 12px;
  padding-bottom: 100px;
  box-sizing: border-box;
  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title-left {
      display: flex;
      align-items: center;
      .title-logo {
        width: 95px;
        height: 22px;
        display: block;
      }
    }
    .title-right {
      border-radius: 50%;
      background-color: var(--bg1);
      width: 27px;
      height: 27px;
      text-align: center;
      line-height: 27px;
      font-size: 12px;
      font-weight: 500;
    }
  }
  .match-info {
    display: flex;
    align-items: center;
    margin-top: 4px;
    img {
      width: 46px;
      height: 46px;
      border-radius: 50%;
      margin-right: 7px;
    }
    .info {
      .name {
        font-size: 15px;
        font-weight: bold;
      }
      .group {
        display: inline-block;
        border-radius: 70px;
        background-color: var(--bg1);
        overflow: hidden;
        font-size: 0px;
        margin-top: 4px;
        .group-label {
          background-color: #337ecc;
          color: #fff;
          padding: 3px 8px;
          font-size: 12px;
        }
        .group-value {
          font-size: 12px;
          padding: 3px 10px;
        }
      }
    }
  }
  .return {
    margin-top: 12px;
    background-color: #fff;
    border-radius: 8px;
    padding: 12px;
    .return-title {
      font-size: 13px;
      font-weight: bold;
      color: #333333;
      margin-bottom: 8px;
    }
    .content {
      font-size: 13px;
      color: #3d3d3d;
    }
  }
  .card-section {
    padding: 0;
    margin-top: 12px;
    .card {
      background: var(--bg1);
      border-radius: 8px;
      padding: 14px 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .card-title {
        font-size: 15px;
        color: #1d2129;
        font-weight: 500;
      }
      .card-link {
        font-size: 14px;
        color: #4aa2f7;
      }
    }
    .card-team {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      .card-title {
        margin-bottom: 10px;
      }
      .card-team-left {
        flex: 1;
        min-width: 0;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      }
      .team-left {
        display: flex;
        align-items: center;
        gap: 12px;
        min-width: 0;
      }
      .team-logo {
        width: 25px;
        height: 25px;
        border-radius: 50%;
        overflow: hidden;
        flex-shrink: 0;
        background: #e8e8e8;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .team-name {
        flex: 1;
        min-width: 0;
        font-size: 15px;
        font-weight: 500;
        color: #1d2129;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .card-team-action {
        flex-shrink: 0;
        margin-left: 16px;
      }
    }
    .card-row {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: stretch;
      gap: 12px;
      margin-top: 12px;
    }
    .card-half {
      width: 167px;
      height: 105px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      .card-half-left {
        flex: 1;
        min-width: 0;
      }
      .card-desc {
        font-size: 13px;
        color: #666;
        margin-top: 12px;
        .num {
          color: #30d55b;
        }
      }
      .card-link {
        flex-shrink: 0;
        margin-left: 8px;
      }
    }
    .card-title-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      .card-title {
        margin-bottom: 0;
      }
      .card-link {
        flex-shrink: 0;
        margin-left: 8px;
        font-size: 14px;
        color: #1989fa;
      }
    }
    .card-player,
    .card-officer,
    .card-fee {
      flex-direction: column;
      align-items: stretch;
      justify-content: flex-start;
      .card-desc {
        margin-top: 12px;
      }
    }
    .card-fee {
      cursor: pointer;
    }
    .card-survey,
    .card-agreement {
      flex-direction: column;
      align-items: stretch;
      justify-content: flex-start;
    }
    .card-agreement.card-half,
    .card-survey.card-half {
      align-items: stretch;
      justify-content: flex-start;
      min-height: 105px;
      height: auto;
    }
    .card-full {
      width: 100%;
      flex: 1 1 100%;
      max-width: 100%;
      // min-height: 98px;
      box-sizing: border-box;
    }
  }

  .go-match-home-btn {
    font-size: 14px;
    font-weight: 400;
    color: #1d2129;
    background: #fff;
    border-radius: 8px;
    text-align: center;
    margin-top: 24px;
  }

  .footer-box {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 88px;
    background-color: #fff;
    box-shadow: 0 -2px 10px 0 rgba(0, 0, 0, 0.05);
  }
  .footer {
    padding: 6px 12px 0 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &.footer-submit-only {
      justify-content: flex-end;
      .left {
        display: none;
      }
    }
    .left {
      font-size: 14px;
      color: #3d3d3d;
      display: flex;
      width: 76px;
      height: 36px;
      border-radius: 5px;
      background-color: #f4f4f5;
      text-align: center;
      justify-content: center;
      align-items: center;
      div {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
      img {
        width: 27px;
        height: 27px;
        border-radius: 50%;
        margin-bottom: 6px;
        margin-left: 12px;
      }
    }
    .right {
      width: 117px;
      height: 45px;
      border-radius: 69px;
      background: #509dea;
      font-size: 15px;
      font-weight: 500;
      color: #ffffff;
      text-align: center;
      line-height: 45px;
    }
  }
}
.agreement-top {
  .agreement-title {
    background-color: #fff;
    padding: 12px 12px 0 12px;
    text-align: center;
    font-weight: 600;
    font-size: 24px;
    margin-bottom: 4px;
  }

  .hint {
    text-align: center;
    font-size: 16px;
    color: #8C8C8C;
  }
}

.notice {
  .notice-title {
    text-align: center;
    font-size: 16px;
    padding: 12px 0;
    // border-bottom: 1px solid #f3f3f3;
  }

  .info {
    padding: 12px;
    white-space: pre-wrap;
  }

  .close {
    text-align: center;
    color: #576B95;
    // border-top: 1px solid #f3f3f3;
    padding: 12px 0;
  }

  .disabled {
    color: #999 !important;
  }
}

#agreement {
  padding: 0 24px 12px 24px;

  .wscnph {
    width: 100%;
  }
}
</style>

<style lang="scss">
.person-info-action-sheet-popup.van-popup--bottom {
  box-sizing: border-box;
  padding-bottom: 14px;
}
</style>
